(async () => {
  const baseComponent=await import(window.theme.modules.baseComponent);
  customElements.define('product-recommendations',class extends baseComponent.default {
    render(){ this.loaded = false; }
    reRender(){
      if (this.loaded || this.requested) return;
      this.recommendationObserver?.disconnect();
      if(!('IntersectionObserver' in window)){this._load();return;}
      this.recommendationObserver=new IntersectionObserver(entries=>{
        if(entries.some(entry=>entry.isIntersecting)){
          this.recommendationObserver.disconnect();this._load();
        }
      },{rootMargin:'300px 0px'});
      this.recommendationObserver.observe(this);
    }
    async _load(){
      if(this.requested)return;
      if (!this.dataset.url) { this.hidden=true; return; }
      this.requested=true;
      const controller = this.controller=new AbortController();
      try{
        const response=await fetch(this.dataset.url,{signal:controller.signal});
        if(!response.ok)throw new Error('Recommendations unavailable');
        const html=document.createElement('div');html.innerHTML=await response.text();
        const recommendations=html.querySelector('product-recommendations');
        if (!this.isConnected || controller.signal.aborted || this.controller !== controller) return;
        this.loaded=true;
        if(recommendations?.querySelector('a[href*="/products/"]'))this.innerHTML=recommendations.innerHTML;
        else this.hidden=true;
      }catch(error){if(error.name!=='AbortError' && this.controller === controller)this.hidden=true;}
      finally {if(this.controller === controller)this.requested=false;}
    }
    disconnectedCallback(){this.recommendationObserver?.disconnect();this.controller?.abort();this.requested=false;super.disconnectedCallback();}
  });
})();
